export default "__VITE_ASSET__Copem$kn__"